import React, { useEffect, useRef, useState } from 'react';

/**
 * A simpler StaffRenderer that directly renders VexFlow
 */
function StaffRenderer({ renderStaff, activeNote, activeMelodyNote }) {
  const containerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const vexflowRef = useRef(null);
  
  // Only load VexFlow once on component mount
  useEffect(() => {
    const loadVexFlow = async () => {
      try {
        // Import the vexflowLoader module
        const { loadVexFlowModules } = await import('../utils/vexflowLoader');
        
        // Load the VexFlow modules
        const vexflow = await loadVexFlowModules();
        
        vexflowRef.current = vexflow;
        setIsLoading(false);
      } catch (err) {
        setError(err.message || 'Failed to load music notation');
        setIsLoading(false);
      }
    };
    
    loadVexFlow();
  }, []);
  
  // Render the staff whenever notes change
  useEffect(() => {
    // Only continue if VexFlow is loaded and we have a container
    if (!vexflowRef.current || !containerRef.current) return;
    
    try {
      // Clear previous content
      containerRef.current.innerHTML = '';
      
      // Render the staff
      renderStaff(vexflowRef.current, containerRef.current);
    } catch (err) {
      setError(err.message || 'Error rendering music notation');
    }
  }, [renderStaff, activeNote, activeMelodyNote, vexflowRef.current]);
  
  return (
    <div className="staff-renderer-wrapper" style={{ 
      width: '100%',
      marginBottom: '20px',
    }}>
      <div
        ref={containerRef}
        className="staff-renderer"
        style={{
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          borderRadius: '4px',
          height: '200px',
          width: '100%',
          position: 'relative'
        }}
      >
        {isLoading && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center'
          }}>
            Loading music notation...
          </div>
        )}
        
        {error && (
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: 'red'
          }}>
            {error}
          </div>
        )}
      </div>
    </div>
  );
}

export default StaffRenderer; 